"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PASSWORD_HEADER_LIST_LONG = exports.PASSWORD_HEADER_LIST_SHORT = exports.PASSWORD_HEADER_START = void 0;

/* eslint-disable import/prefer-default-export */
var PASSWORD_HEADER_START = "<h3>Set your password</h3>\n\t\t<p>Your password must contain the following:</p>";
exports.PASSWORD_HEADER_START = PASSWORD_HEADER_START;
var PASSWORD_HEADER_LIST_SHORT = "<ul  aria-label=\"password criteria list\">\n<li>an uppercase letter</li>\n<li>a lowercase letter</li>\n<li>a number</li>\n<li> a special character</li>\n</ul>";
exports.PASSWORD_HEADER_LIST_SHORT = PASSWORD_HEADER_LIST_SHORT;
var PASSWORD_HEADER_LIST_LONG = "<ul aria-label=\"password criteria list\">\n<li>minimum of ten (10) characters</li>\n<li>an uppercase letter</li>\n<li>a lowercase letter</li>\n<li>a number</li>\n<li>a special character</li>\n<li>no part of your email address</li>\n</ul>";
exports.PASSWORD_HEADER_LIST_LONG = PASSWORD_HEADER_LIST_LONG;
//# sourceMappingURL=constants.js.map